import { createContext, useContext } from "react";
import { OFFICES } from "../lib/regions";

const RegionContext = createContext(null);

export const RegionProvider = ({ children }) => (
  <RegionContext.Provider value={{ office: OFFICES.europe }}>{children}</RegionContext.Provider>
);

export const useRegion = () => useContext(RegionContext);
